import CouponModel from "models/CouponModel";
import toast from "react-hot-toast";
import * as Posthog from "@qoohoo/common/utils/analytics/posthog";
import httpf from "utils/api/frontend/httpf";
import { QOOHOO_WEBSITE_DOMAIN } from "constants/env";
import useEntityStore from "store/entityStore";
import EntityModel from "models/EntityModel";
import useCouponState from "store/couponState";

const validateCoupon = async (couponCode) => {
  let responseData;

  const {setCoupon, setIsLoading, isLoading} = useCouponState.getState();
  const entity = useEntityStore.getState().entity;
  const uid = entity.data.uid;

  if(isLoading) return;

  let type;

  if(entity.isOneToOneMeeting) {
    type = EntityModel.types.one_to_one_meeting;
  } else if(entity.isPremiumContent) {
    type = EntityModel.types.premium_content;
  } else if(entity.isRegularChannel || entity.isCourse) {
    type = EntityModel.types.channel;
  }

  try {
    setIsLoading(true);
    
    responseData = await httpf.post(`${QOOHOO_WEBSITE_DOMAIN}/api/validate-coupon`, {
      coupon: couponCode,
      [type]: uid,
    });

    const _coupon = new CouponModel({...responseData.data, code:couponCode});
    setCoupon(_coupon);

    const data = {
      current_screen: "checkout_view",
      current_route: window.location.pathname,
      // payment_gateway: "razorpay",
      coupon_code: couponCode,
      platform: "web",
    };

    console.log("Posthog button click data: coupon_successful", data);

    Posthog.buttonClick("coupon_successful", data);

  } catch (err) {
    const data = {
      current_screen: "checkout_view",
      current_route: window.location.pathname,
      // payment_gateway: "razorpay",
      coupon_code: couponCode,
      failure_reason: err?.response?.data?.data?.message || err?.response?.data?.message || err?.response?.data?.data?.non_field_errors || err?.response?.data?.non_field_errors || err?.response?.data?.data,
      platform: "web",
    };

    console.log("Posthog button click data: coupon_failed", data);

    Posthog.buttonClick("coupon_failed", data);
    toast.error("The coupon is not valid or has expired"); // err?.message
  } finally {
    setIsLoading(false);
  }
};

export default validateCoupon;
